"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportItemType = exports.ExportType = void 0;
var ExportType;
(function (ExportType) {
    // Standard export used by all systems
    ExportType["EXPORT"] = "EXPORT";
    // Bank feed export currently only used by Xero
    ExportType["BANKFEED"] = "BANKFEED";
})(ExportType = exports.ExportType || (exports.ExportType = {}));
var ExportItemType;
(function (ExportItemType) {
    ExportItemType["EXPENSE"] = "EXPENSE";
    ExportItemType["REFUND"] = "REFUND";
    ExportItemType["WALLET_LOAD"] = "WALLET_LOAD";
    ExportItemType["WALLET_UNLOAD"] = "WALLET_UNLOAD";
    ExportItemType["CHARGE_BACK"] = "CHARGE_BACK";
    ExportItemType["REIMBURSEMENT"] = "REIMBURSEMENT";
    /** @deprecated use `REPAYMENT` instead */
    ExportItemType["CASH_HANDOVER"] = "CASH_HANDOVER";
    ExportItemType["REPAYMENT"] = "REPAYMENT";
    ExportItemType["MANUAL_EXPENSE"] = "MANUAL_EXPENSE";
    ExportItemType["BILL_INVOICE"] = "BILL_INVOICE";
    /**
     * Used to specify expenses which affect multiple
     * balance accounts
     */
    ExportItemType["ACCOUNT_TRANSFER"] = "ACCOUNT_TRANSFER";
})(ExportItemType = exports.ExportItemType || (exports.ExportItemType = {}));
var FailureReason;
(function (FailureReason) {
    // For errors that occur while executing the export of a receipt
    FailureReason["EXPORT_RECEIPT_FAILURE"] = "EXPORT_RECEIPT_FAILURE";
    // For errors that occur while running the export consolidation function
    FailureReason["EXPORT_RECEIPT_CONVERSION_FAILURE"] = "EXPORT_RECEIPT_CONVERSION_FAILURE";
    /**
     * For when export item does not satisfy ERP requirements (eg not supported currency, missed mandatory
     * values such as account/contra-account fields for some types of export items)
     */
    FailureReason["EXPORT_ITEM_VALIDATION_FAILURE"] = "EXPORT_ITEM_VALIDATION_FAILURE";
    /**
     * For when we are unable to create an export item entity (transaction, journalLine etc depending on ERP) on 3rd party side.
     */
    FailureReason["EXPORT_ITEM_EXPORT_FAILURE"] = "EXPORT_ITEM_EXPORT_FAILURE";
    // For when the failure of the export was as a result of a timeout
    FailureReason["EXPORT_TIMEOUT_FAILURE"] = "EXPORT_TIMEOUT_FAILURE";
})(FailureReason || (FailureReason = {}));
//# sourceMappingURL=export.js.map